<template>
  <div>
    <!-- <MasterLayout> -->
    <div class="pb-3 pl-4 pr-3">
      <div class="row">
        <div class="col-md-7 col-sm-12">
          <div class="mt-4 ml-3">
            <img src="https://epump.com.ng/images/logo2.svg" width="153" />
          </div>
        </div>

        <div class="col-md-5 col-sm-12">
          <!-- <div class="d-flex flex-sm-row flex-column justify-content-between"></div> -->
          <div
            class="p-3 cursor-pointer d-flex flex-sm-row flex-column justify-content-between"
          >
            <div>
              <!-- SELECT LANGUAGE -->
              <select
                @change="changeLanguage"
                v-model="usedLang"
                class="w-lg-100 w-md-50 mb-3 mb-md-3 mb-sm-5 mb-lg-0"
              >
                <option class="p2" value="fr">FR</option>
                <option value="en">EN</option>
              </select>
              <!-- <select
                @change="changeLanguage"
                class="w-lg-100 mb-3 mb-md-3 mb-lg-0"
              >
                <option disabled value="en">
                  {{ $t("text.cMasterLayout.selectLanguage") }}
                </option>
                <option value="fr">FR</option>
                <option value="en">EN</option>
              </select> -->
            </div>
            <div @click="signOutUser">
              <img src="@/assets/img/logout.png" width="35" class="mr-2" />
              {{ $t("text.cMasterLayout.logOut") }}
            </div>
          </div>
        </div>
      </div>
      <section class="pump__details__section_2">
        <div class="row mt-4">
          <div class="col-md-8">
            <div
              class="row align-items-center white-bg py-3 mb-4 pt-5 large-card"
            >
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <i
                    class="fa fa-users primary-color"
                    aria-hidden="true"
                    style="font-size: 35px"
                  ></i>
                </div>
              </div>
              <div class="col-md-8">
                <h4 class="primary-color font-600">
                  {{ $t("text.cMasterLayout.manageCompanies") }}
                </h4>
                <p class="light-grey-text mt-3">
                  {{ $t("text.cMasterLayout.mgtDesc") }}
                </p>
              </div>
              <div class="col-md-3 flexify"></div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="our_branches__header text-center">
                    {{ $t("text.clickButtons.companies") }}
                  </h3>
                  <div class="dealer__icon__wrapper mt-3">
                    <div class="dealer__icon__div text-center">
                      <div>
                        <i
                          class="fa fa-users text-white"
                          aria-hidden="true"
                          style="font-size: 35px"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <h3 class="our_branches__header text-center mt-2">
                    {{ companiesCount }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section class="pump__details__section_2">
      <div class="row add_driver_row record__expenses">
        <div class="col-md-12 col-lg-12">
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="false"
            :allowSorting="true"
            :pageSettings="pageSettings"
            :toolbar="toolbar"
            :searchSettings="search"
            :allowTextWrap="true"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick"
            :rowDataBound="rowDataBound"
            :actionBegin="actionHandler"
            :locale="usedLang"
          >
            <e-columns>
              <e-column
                :template="companies_image"
                width="100"
                headerText="Logo"
              ></e-column>
              <e-column
                width="200"
                field="name"
                :headerText="$t('text.aaDetailsModal.companyName')"
              ></e-column>
              <e-column
                width="130"
                field="numberOfBranches"
                :headerText="$t('text.cDashboard.branches')"
              ></e-column>
              <e-column
                width="130"
                field="numberOfDealers"
                :headerText="$t('text.cMasterLayout.dealers')"
              ></e-column>
              <e-column
                width="200"
                field="country"
                :headerText="$t('text.editStaff.country')"
              ></e-column>
              <e-column
                width="200"
                field="city"
                :headerText="$t('text.editStaff.city')"
              ></e-column>
              <e-column
                :template="CompaniesTemp"
                :headerText="$t('text.cards.action')"
                width="300"
              ></e-column>
            </e-columns>
          </ejs-grid>
          <TableLoader :showLoader="showLoader" />
          <div class="mt-3" style="margin: 0 auto">
            <Paginator
              v-show="!showLoader"
              :total-pages="totalPages"
              :per-page="pageSize"
              :current-page="currentPage"
              @pagechanged="onPageChange"
              @getPageSize="getPageSize"
              :pageSize="pageSize"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- </MasterLayout> -->
  </div>
</template>

<script>
import Vue from "vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import CompanyUsersTemplate from "@/components/TableTemplates/companyUsers";
import UserStatusTemp from "@/components/Templates/userStatusTemp";
import Paginator from "@/components/Paginator.vue";
import Templates from "@/components/Templates/imageTemplates/companies_image";
import CompaniesTemp from "@/components/Templates/companiesTemp";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Companies :: Epump Portal",
  name: "Users",
  components: {
    // MasterLayout,
    TableLoader,
    Paginator,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      sortType: "",
      sortColumn: "",
      searchValue: "",
      companiesCount: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      searchTotalPages: 1,
      showLoader: true,
      tableCount: 0,
      backgroundUrl,
      usersCount: 0,
      cardBackgroundUrl,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      partnerId: "",
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      UsersTemplate: function () {
        return {
          template: CompanyUsersTemplate,
        };
      },
      UserStatusTemp: function () {
        return {
          template: UserStatusTemp,
        };
      },
      companies_image: function () {
        return {
          template: Templates,
        };
      },
      CompaniesTemp: function () {
        return {
          template: CompaniesTemp,
        };
      },
    };
  },

  mounted() {
    const contLang = this.$root.$i18n.locale.split("-")[0];
    this.$store.commit("setLanguage", contLang);
    this.usedLang = this.$store.getters.getLanguage;

    if (this.userDetails.roles.includes("PartnerAdmin")) {
      this.getPartnerInfo();
    }
    if (this.userDetails.roles.includes("SupportAdmin")) {
      this.getCompanies();
    }
    $(".e-input").keyup(function (e) {
      if (e.keyCode === 13) {
        searchFun(e, 13);
      } else {
        searchFun(e, 1);
      }
    });
    const searchFun = (event, number) => {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      this.searchValue = value;
      if (number !== 13 && value.length > 3) {
        this.getCompanies();
      }
      if (number == 13) {
        this.getCompanies();
      }
      if (!value.length) {
        this.getCompanies();
      }
    };

    this.$eventHub.$on("refreshCompaniesList", () => {
      this.currentPage = 1;
      this.getCompanies();
    });
    this.getCompanies();
  },
  watch: {
    partnerId() {
      this.getCompanies();
    },
  },
  methods: {
    changeLanguage(e) {
      this.$store.commit("setLanguage", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      this.$eventHub.$emit("remountCom");
      // this.refreshGrid();
    },

    getPartnerInfo() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/AcquiringPartner/UserPartner/${this.userDetails.email}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.partnerId = res.data.acquiringPartnerId;
          this.$eventHub.$emit("getPartnerId", res.data.acquiringPartnerId);
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    signOutUser() {
      const answer = window.confirm(
        this.$t("text.cMasterLayout.confirmLogout")
      );
      if (answer) {
        if (localStorage.getItem("locale")) {
          const locale = localStorage.getItem("locale");
          this.$store.commit("setBaseLocale", locale);
        }
        this.$store.commit("setModalShown", false);
        this.$store.commit("setStatusInfo", {});
        this.$store.commit("setBranchModalShown", false);
        this.$store.commit("setBranchStatusInfo", {});

        this.$store.dispatch("logout");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    rowDataBound: function (args) {
      if (args.data["status"] === "Active") {
        args.row.cells[4].style.color = "green";
      }
      if (args.data["status"] === "Deactivated") {
        args.row.cells[4].style.color = "blue";
      }
      if (args.data["status"] === "Suspended") {
        args.row.cells[4].style.color = "red";
      }
    },
    getPageSize(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.getCompanies.totalNumber / pageSize);
      this.getCompanies();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getCompanies();
    },
    actionHandler: function (args) {
      if (args.requestType == "sorting") {
        if (args.direction) {
          this.sortType = args.direction;
          this.sortColumn = args.columnName;
        } else {
          this.sortType = "";
          this.sortColumn = "";
        }

        this.getCompanies();
      }
    },
    getCompanies() {
      let url;
      if (this.partnerId) {
        url = `${configObject.apiBaseUrl}/Company?PageNumber=${
          this.currentPage
        }&PageSize=${this.pageSize}&Search=${this.searchValue}&Order=${
          this.sortType
        }&SortName=${this.sortColumn}&partnerId=${
          this.partnerId ? this.partnerId : ""
        }`;
      } else {
        url = `${configObject.apiBaseUrl}/Company?PageNumber=${this.currentPage}&PageSize=${this.pageSize}&Search=${this.searchValue}&Order=${this.sortType}&SortName=${this.sortColumn}`;
      }
      this.axios
        .get(url, configObject.authConfig())
        .then((res) => {
          let index = 0 + (this.currentPage - 1) * this.pageSize;
          res.data.data.forEach((el) => {
            el.index = ++index;
          });
          sessionStorage.clear();
          localStorage.setItem("companiesList", JSON.stringify(res.data.data));
          this.companiesCount = res.data.totalNumber;
          this.totalPages = Math.ceil(res.data.totalNumber / this.pageSize);
          this.tableCount = res.data.totalNumber;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data.data,
          });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style scoped>
body {
  background: #f0f8ff38 !important;
}
.card_container {
  box-shadow: 0px 0px 1px #6363b36e !important;
  padding: 6px !important;
}
.large-card {
  box-shadow: 0px 0px 1px #6363b36e !important;
  border-radius: 10px !important;
}
</style>
